import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { MDSLink, MDSTextVariant } from "@/mds";

export const AgentLinkButton = ({
  children,
  className,
  onClick,
  truncate = false,
  variant = MDSTextVariant.TextS,
}: {
  children: ReactNode;
  className?: string;
  onClick: () => void;
  truncate?: boolean;
  variant?: MDSTextVariant;
}) => (
  <StyledLink $truncate={truncate} className={className} variant={variant} onPress={onClick}>
    {children}
  </StyledLink>
);

const StyledLink = styled(MDSLink)<{ $truncate: boolean }>`
  max-width: 100%;
  text-align: left;
  text-decoration-thickness: 1px;
  text-underline-offset: ${({ $truncate }) => ($truncate ? "1px" : "3px")};

  ${({ $truncate }) =>
    $truncate
      ? `
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      `
      : ""}
`;
